<template>
  <div>
    <Position @titleFromChild="onTitleChanged"/>
  </div>
</template>

<script>
import Position from './Position.vue'

export default {
  name: 'home',
  data: function () {
    return {
    }
  },
  components: {
    Position
  },
  created () {

  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onTitleChanged (title) {
      this.$emit('titleFromChild', title)
    }
  }
}
</script>

<style lang="scss">
</style>
